import { SvelteStyleStoreFactory, StyleUtilities } from '@collectivehealth/dls-styles';
import '@collectivehealth/dls-icon-label';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

function noop() {}

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

function subscribe(store) {
  for (var _len = arguments.length, callbacks = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    callbacks[_key - 1] = arguments[_key];
  }

  var unsub = store.subscribe.apply(store, callbacks);
  return unsub.unsubscribe ? function () {
    return unsub.unsubscribe();
  } : unsub;
}

function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}

function append(target, node) {
  target.appendChild(node);
}

function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function element(name) {
  return document.createElement(name);
}

function text(data) {
  return document.createTextNode(data);
}

function space() {
  return text(' ');
}

function empty() {
  return text('');
}

function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function set_custom_element_data(node, prop, value) {
  if (prop in node) {
    node[prop] = value;
  } else {
    attr(node, prop, value);
  }
}

function children(element) {
  return Array.from(element.childNodes);
}

function set_data(text, data) {
  data = '' + data;
  if (text.data !== data) text.data = data;
}

var HtmlTag =
/*#__PURE__*/
function () {
  function HtmlTag(html) {
    var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, HtmlTag);

    this.e = element('div');
    this.a = anchor;
    this.u(html);
  }

  _createClass(HtmlTag, [{
    key: "m",
    value: function m(target) {
      var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      for (var i = 0; i < this.n.length; i += 1) {
        insert(target, this.n[i], anchor);
      }

      this.t = target;
    }
  }, {
    key: "u",
    value: function u(html) {
      this.e.innerHTML = html;
      this.n = Array.from(this.e.childNodes);
    }
  }, {
    key: "p",
    value: function p(html) {
      this.d();
      this.u(html);
      this.m(this.t, this.a);
    }
  }, {
    key: "d",
    value: function d() {
      this.n.forEach(detach);
    }
  }]);

  return HtmlTag;
}();

var current_component;

function set_current_component(component) {
  current_component = component;
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

function flush() {
  var seen_callbacks = new Set();

  do {
    // first, call beforeUpdate functions
    // and update components
    while (dirty_components.length) {
      var component = dirty_components.shift();
      set_current_component(component);
      update(component.$$);
    }

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var i = 0; i < render_callbacks.length; i += 1) {
      var callback = render_callbacks[i];

      if (!seen_callbacks.has(callback)) {
        callback(); // ...so guard against infinite loops

        seen_callbacks.add(callback);
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}

var outroing = new Set();

function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}

function mount_component(component, target, anchor) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor); // onMount happens before the initial afterUpdate

  add_render_callback(function () {
    var new_on_destroy = on_mount.map(run).filter(is_function);

    if (on_destroy) {
      on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
    } else {
      // Edge case - component was destroyed immediately,
      // most likely as a result of a binding initialising
      run_all(new_on_destroy);
    }

    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}

function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }

  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var dirty = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [-1];
  var parent_component = current_component;
  set_current_component(component);
  var prop_values = options.props || {};
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : []),
    // everything else
    callbacks: blank_object(),
    dirty: dirty
  };
  var ready = false;
  $$.ctx = instance ? instance(component, prop_values, function (i, ret) {
    var value = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if ($$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }

    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.l(children(options.target));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }

  set_current_component(parent_component);
}

var SvelteElement;

if (typeof HTMLElement === 'function') {
  SvelteElement =
  /*#__PURE__*/
  function (_CustomElement2) {
    _inherits(SvelteElement, _CustomElement2);

    function SvelteElement() {
      var _this;

      _classCallCheck(this, SvelteElement);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SvelteElement).call(this));

      _this.attachShadow({
        mode: 'open'
      });

      return _this;
    }

    _createClass(SvelteElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        // @ts-ignore todo: improve typings
        for (var key in this.$$.slotted) {
          // @ts-ignore todo: improve typings
          this.appendChild(this.$$.slotted[key]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        destroy_component(this, 1);
        this.$destroy = noop;
      }
    }, {
      key: "$on",
      value: function $on(type, callback) {
        // TODO should this delegate to addEventListener?
        var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return function () {
          var index = callbacks.indexOf(callback);
          if (index !== -1) callbacks.splice(index, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set() {// overridden by instance, if it has props
      }
    }]);

    return SvelteElement;
  }(_CustomElement);
}

var disabled = "mcc2c9d9e6_disabled";
var dark = "mcc2c9d9e6_dark";
var light = "mcc2c9d9e6_light";
var styles = ".mcc2c9d9e6_disabled{pointer-events:none!important}:host([disable]){pointer-events:none!important}dls-button[disable]{pointer-events:none!important}.mcc2c9d9e6_disabled[disabled]:after{border-color:transparent!important}.mcc2c9d9e6_disabled[disabled]:active:after,.mcc2c9d9e6_disabled[disabled]:after,.mcc2c9d9e6_disabled[disabled]:focus:after,.mcc2c9d9e6_disabled[disabled]:hover:after{box-shadow:none!important}.mcc2c9d9e6_disabled.mcc2c9d9e6_dark{color:hsla(0,0%,96.1%,.7)!important}.mcc2c9d9e6_disabled.mcc2c9d9e6_dark:after{background-color:rgba(62,57,57,.3)!important}.mcc2c9d9e6_disabled.mcc2c9d9e6_light{color:#999!important}.mcc2c9d9e6_disabled.mcc2c9d9e6_light:after{background-color:#eee!important}";

var buttonStyleStore = SvelteStyleStoreFactory();
var subscribe$1 = buttonStyleStore.subscribe,
    addStyles = buttonStyleStore.addStyles;

addStyles([{
  attributeName: 'disable',
  attributeValue: 'disable',
  className: disabled,
  styles: styles,
  variations: {
    dark: dark,
    light: light
  }
}]);

var medium = "mc146c1515_medium";
var circle = "mc146c1515_circle";
var pill = "mc146c1515_pill";
var styles$1 = ".mc146c1515_medium{font-size:18px;letter-spacing:.3px;line-height:49px}.mc146c1515_medium,.mc146c1515_medium:after,.mc146c1515_medium:before{border-radius:26px}.mc146c1515_medium:focus:before{border-radius:39px}.mc146c1515_circle{align-items:center;display:flex;height:52px;justify-content:center;padding:0;text-align:center;width:52px}.mc146c1515_pill{max-height:52px;padding:0 26px}";

addStyles([{
  attributeName: 'size',
  attributeValue: 'medium',
  className: medium,
  styles: styles$1,
  variations: {
    circle: circle,
    pill: pill
  }
}]);

var white = "mc4a4cb90b_white";
var toggle = "mc4a4cb90b_toggle";
var pressed = "mc4a4cb90b_pressed";
var shadowed = "mc4a4cb90b_shadowed";
var styles$2 = ".mc4a4cb90b_white{color:#3e3939}.mc4a4cb90b_white:after{background-color:#fff;border-color:#e0e3e4}.mc4a4cb90b_white:active:after,.mc4a4cb90b_white:focus:after,.mc4a4cb90b_white:hover:after{background-color:#f5f5f5;border-color:#999;color:#232121}.mc4a4cb90b_white:focus:before{border-color:#999}.mc4a4cb90b_white.mc4a4cb90b_toggle.mc4a4cb90b_pressed:active:after,.mc4a4cb90b_white.mc4a4cb90b_toggle.mc4a4cb90b_pressed:after,.mc4a4cb90b_white.mc4a4cb90b_toggle.mc4a4cb90b_pressed:focus:after,.mc4a4cb90b_white.mc4a4cb90b_toggle.mc4a4cb90b_pressed:hover:after{border-color:#706f6e}.mc4a4cb90b_shadowed:after{box-shadow:0 4px 4px rgba(0,0,0,.08)}.mc4a4cb90b_shadowed:focus:after,.mc4a4cb90b_shadowed:hover:after{box-shadow:0 6px 8px rgba(0,0,0,.08)}.mc4a4cb90b_shadowed:active:after{box-shadow:0 2px 2px rgba(0,0,0,.16)}";

addStyles([{
  attributeName: 'theme',
  attributeValue: 'white',
  className: white,
  styles: styles$2,
  variations: {
    pressed: pressed,
    shadowed: shadowed,
    toggle: toggle
  }
}]);

function initializeFormParticipant(type, slottedElements) {
  if (type === 'submit' && slottedElements.length) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = slottedElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var element = _step.value;

        if (element.tagName === 'BUTTON' && element.getAttribute('type') === 'submit') {
          element.setAttribute('tabindex', -1);
          element.setAttribute('aria-hidden', true);
          return element;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return false;
}

function participateInForm(type, formParticipant, usesPolyfill) {
  if (type === 'submit' && formParticipant && !usesPolyfill) {
    formParticipant.click();
  }
}

var button = {
    "button": "mc3e53fd3b_button",
    "_formParticipantSlot": "mc3e53fd3b__formParticipantSlot"
};
var button$1 = "mc3e53fd3b_button";
var _formParticipantSlot = "mc3e53fd3b__formParticipantSlot";
var styles$3 = ":host{display:inline-block}:host([width=fill]){display:block}dls-button{display:inline-block}dls-button[width=fill]{display:block}.mc3e53fd3b_button{-webkit-font-smoothing:antialiased;-webkit-transform-style:preserve-3d;background:none transparent;color:inherit;cursor:pointer;display:block;font:inherit;font-weight:700;line-height:1;position:relative;text-align:center;white-space:nowrap;width:100%;z-index:0}.mc3e53fd3b_button:after,.mc3e53fd3b_button:before{content:\"\";position:absolute;z-index:-1}.mc3e53fd3b_button,.mc3e53fd3b_button:after,.mc3e53fd3b_button:before{border:1.5px solid transparent;box-sizing:border-box;overflow:visible;transition:all .2s ease-out}.mc3e53fd3b_button:before{bottom:-6.5px;left:-6.5px;right:-6.5px;top:-6.5px}.mc3e53fd3b_button:after{bottom:-1.5px;left:-1.5px;right:-1.5px;top:-1.5px}.mc3e53fd3b_button:active,.mc3e53fd3b_button:active:after,.mc3e53fd3b_button:active:before{transition-duration:.1s}.mc3e53fd3b_button:focus{outline:none}.mc3e53fd3b_button::-moz-focus-inner{border:0}.mc3e53fd3b_button:focus:before{opacity:1}.mc3e53fd3b_button:active:before,.mc3e53fd3b_button:hover:before{opacity:0}.mc3e53fd3b_button:focus:after,.mc3e53fd3b_button:focus:before,.mc3e53fd3b_button:hover:after,.mc3e53fd3b_button:hover:before{transform:scale(1.02)}.mc3e53fd3b_button:active:after,.mc3e53fd3b_button:active:before{transform:scale(.98)}a.mc3e53fd3b_button{text-decoration:none}@-moz-document url-prefix(){.mc3e53fd3b_button,.mc3e53fd3b_button:after,.mc3e53fd3b_button:before{border-width:2px}.mc3e53fd3b_button:before{bottom:-7px;left:-7px;right:-7px;top:-7px}.mc3e53fd3b_button:after{bottom:-2px;left:-2px;right:-2px;top:-2px}}.mc3e53fd3b__formParticipantSlot{position:absolute;left:-9999px}";

var buttonStyles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': button,
  button: button$1,
  _formParticipantSlot: _formParticipantSlot,
  styles: styles$3
});

function create_if_block_2(ctx) {
  var html_tag;
  return {
    c: function c() {
      html_tag = new HtmlTag(
      /*polyfillStyleTags*/
      ctx[10], null);
    },
    m: function m(target, anchor) {
      html_tag.m(target, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*polyfillStyleTags*/
      1024) html_tag.p(
      /*polyfillStyleTags*/
      ctx[10]);
    },
    d: function d(detaching) {
      if (detaching) html_tag.d();
    }
  };
} // (7:0) {#if !style.usesPolyfill}


function create_if_block_1(ctx) {
  var div0;
  var t0;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[9].sheet("size/".concat(
  /*size*/
  ctx[4])) + "";
  var t1;
  var div2;
  var raw2_value =
  /*$altStyles*/
  ctx[9].sheet("theme/".concat(
  /*theme*/
  ctx[6])) + "";
  var t2;
  var div3;
  var raw3_value =
  /*$altStyles*/
  ctx[9].sheet("disable/disable") + "";
  return {
    c: function c() {
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      div2 = element("div");
      t2 = space();
      div3 = element("div");
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(div2, "data-style", "");
      attr(div3, "data-style", "");
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*buttonStylesheet*/
      ctx[14];
      insert(target, t0, anchor);
      insert(target, div1, anchor);
      div1.innerHTML = raw1_value;
      insert(target, t1, anchor);
      insert(target, div2, anchor);
      div2.innerHTML = raw2_value;
      insert(target, t2, anchor);
      insert(target, div3, anchor);
      div3.innerHTML = raw3_value;
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*$altStyles, size*/
      528 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[9].sheet("size/".concat(
      /*size*/
      ctx[4])) + "")) div1.innerHTML = raw1_value;
      if (dirty &
      /*$altStyles, theme*/
      576 && raw2_value !== (raw2_value =
      /*$altStyles*/
      ctx[9].sheet("theme/".concat(
      /*theme*/
      ctx[6])) + "")) div2.innerHTML = raw2_value;
      if (dirty &
      /*$altStyles*/
      512 && raw3_value !== (raw3_value =
      /*$altStyles*/
      ctx[9].sheet("disable/disable") + "")) div3.innerHTML = raw3_value;
    },
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t0);
      if (detaching) detach(div1);
      if (detaching) detach(t1);
      if (detaching) detach(div2);
      if (detaching) detach(t2);
      if (detaching) detach(div3);
    }
  };
} // (30:0) {:else}


function create_else_block(ctx) {
  var button;
  var dls_icon_label;
  var slot0;
  var t0;
  var slot1;
  var t1;
  var t2;
  var slot2;
  var button_class_value;
  var t3;
  var div;
  var slot3;
  var div_class_value;
  var dispose;
  return {
    c: function c() {
      button = element("button");
      dls_icon_label = element("dls-icon-label");
      slot0 = element("slot");
      t0 = space();
      slot1 = element("slot");
      t1 = text(
      /*label*/
      ctx[3]);
      t2 = space();
      slot2 = element("slot");
      t3 = space();
      div = element("div");
      slot3 = element("slot");
      attr(slot0, "name", "button-icon");
      attr(slot0, "slot", "icon-label-glyph");
      attr(slot1, "name", "button-label");
      attr(slot1, "slot", "icon-label-text");
      set_custom_element_data(dls_icon_label, "position",
      /*iconposition*/
      ctx[2]);
      set_custom_element_data(dls_icon_label, "space",
      /*iconspace*/
      ctx[0]);
      set_custom_element_data(dls_icon_label, "theme",
      /*iconLabelTheme*/
      ctx[8]);
      attr(button, "class", button_class_value = "" + (
      /*style*/
      ctx[15].is("button") + " " +
      /*optionalClassNames*/
      ctx[13]));
      button.disabled =
      /*isDisabled*/
      ctx[12];
      attr(button, "type",
      /*type*/
      ctx[7]);
      attr(slot3, "name", "button-form-participant");
      attr(div, "class", div_class_value =
      /*style*/
      ctx[15].is("_formParticipantSlot"));
      attr(div, "tabindex", "-1");
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, dls_icon_label);
      append(dls_icon_label, slot0);
      append(dls_icon_label, t0);
      append(dls_icon_label, slot1);
      append(slot1, t1);
      append(dls_icon_label, t2);
      append(dls_icon_label, slot2);
      insert(target, t3, anchor);
      insert(target, div, anchor);
      append(div, slot3);
      dispose = [listen(button, "click",
      /*forwardFormSubmission*/
      ctx[16]), listen(slot3, "slotchange",
      /*initializeFormParticipant*/
      ctx[17])];
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*label*/
      8) set_data(t1,
      /*label*/
      ctx[3]);

      if (dirty &
      /*iconposition*/
      4) {
        set_custom_element_data(dls_icon_label, "position",
        /*iconposition*/
        ctx[2]);
      }

      if (dirty &
      /*iconspace*/
      1) {
        set_custom_element_data(dls_icon_label, "space",
        /*iconspace*/
        ctx[0]);
      }

      if (dirty &
      /*iconLabelTheme*/
      256) {
        set_custom_element_data(dls_icon_label, "theme",
        /*iconLabelTheme*/
        ctx[8]);
      }

      if (dirty &
      /*optionalClassNames*/
      8192 && button_class_value !== (button_class_value = "" + (
      /*style*/
      ctx[15].is("button") + " " +
      /*optionalClassNames*/
      ctx[13]))) {
        attr(button, "class", button_class_value);
      }

      if (dirty &
      /*isDisabled*/
      4096) {
        button.disabled =
        /*isDisabled*/
        ctx[12];
      }

      if (dirty &
      /*type*/
      128) {
        attr(button, "type",
        /*type*/
        ctx[7]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      if (detaching) detach(t3);
      if (detaching) detach(div);
      run_all(dispose);
    }
  };
} // (12:6) {#if href}


function create_if_block(ctx) {
  var a;
  var dls_icon_label;
  var slot0;
  var t0;
  var slot1;
  var t1;
  var t2;
  var slot2;
  var a_class_value;
  return {
    c: function c() {
      a = element("a");
      dls_icon_label = element("dls-icon-label");
      slot0 = element("slot");
      t0 = space();
      slot1 = element("slot");
      t1 = text(
      /*label*/
      ctx[3]);
      t2 = space();
      slot2 = element("slot");
      attr(slot0, "name", "button-icon");
      attr(slot0, "slot", "icon-label-glyph");
      attr(slot1, "name", "button-label");
      attr(slot1, "slot", "icon-label-text");
      set_custom_element_data(dls_icon_label, "position",
      /*iconposition*/
      ctx[2]);
      set_custom_element_data(dls_icon_label, "space",
      /*iconspace*/
      ctx[0]);
      set_custom_element_data(dls_icon_label, "theme",
      /*iconLabelTheme*/
      ctx[8]);
      attr(a, "class", a_class_value = "" + (
      /*style*/
      ctx[15].is("button") + " " +
      /*optionalClassNames*/
      ctx[13]));
      attr(a, "href",
      /*href*/
      ctx[1]);
      attr(a, "rel",
      /*formattedRel*/
      ctx[11]);
      attr(a, "target",
      /*target*/
      ctx[5]);
    },
    m: function m(target, anchor) {
      insert(target, a, anchor);
      append(a, dls_icon_label);
      append(dls_icon_label, slot0);
      append(dls_icon_label, t0);
      append(dls_icon_label, slot1);
      append(slot1, t1);
      append(dls_icon_label, t2);
      append(dls_icon_label, slot2);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*label*/
      8) set_data(t1,
      /*label*/
      ctx[3]);

      if (dirty &
      /*iconposition*/
      4) {
        set_custom_element_data(dls_icon_label, "position",
        /*iconposition*/
        ctx[2]);
      }

      if (dirty &
      /*iconspace*/
      1) {
        set_custom_element_data(dls_icon_label, "space",
        /*iconspace*/
        ctx[0]);
      }

      if (dirty &
      /*iconLabelTheme*/
      256) {
        set_custom_element_data(dls_icon_label, "theme",
        /*iconLabelTheme*/
        ctx[8]);
      }

      if (dirty &
      /*optionalClassNames*/
      8192 && a_class_value !== (a_class_value = "" + (
      /*style*/
      ctx[15].is("button") + " " +
      /*optionalClassNames*/
      ctx[13]))) {
        attr(a, "class", a_class_value);
      }

      if (dirty &
      /*href*/
      2) {
        attr(a, "href",
        /*href*/
        ctx[1]);
      }

      if (dirty &
      /*formattedRel*/
      2048) {
        attr(a, "rel",
        /*formattedRel*/
        ctx[11]);
      }

      if (dirty &
      /*target*/
      32) {
        attr(a, "target",
        /*target*/
        ctx[5]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(a);
    }
  };
}

function create_fragment(ctx) {
  var if_block0_anchor;
  var t0;
  var t1;
  var if_block2_anchor;
  var if_block0 =
  /*style*/
  ctx[15].usesPolyfill && create_if_block_2(ctx);
  var if_block1 = !
  /*style*/
  ctx[15].usesPolyfill && create_if_block_1(ctx);

  function select_block_type(ctx, dirty) {
    if (
    /*href*/
    ctx[1]) return create_if_block;
    return create_else_block;
  }

  var current_block_type = select_block_type(ctx);
  var if_block2 = current_block_type(ctx);
  return {
    c: function c() {
      if (if_block0) if_block0.c();
      if_block0_anchor = empty();
      t0 = space();
      if (if_block1) if_block1.c();
      t1 = space();
      if_block2.c();
      if_block2_anchor = empty();
      this.c = noop;
    },
    m: function m(target, anchor) {
      if (if_block0) if_block0.m(document.head, null);
      append(document.head, if_block0_anchor);
      insert(target, t0, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t1, anchor);
      if_block2.m(target, anchor);
      insert(target, if_block2_anchor, anchor);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (
      /*style*/
      ctx[15].usesPolyfill) if_block0.p(ctx, dirty);
      if (!
      /*style*/
      ctx[15].usesPolyfill) if_block1.p(ctx, dirty);

      if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block2) {
        if_block2.p(ctx, dirty);
      } else {
        if_block2.d(1);
        if_block2 = current_block_type(ctx);

        if (if_block2) {
          if_block2.c();
          if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
        }
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (if_block0) if_block0.d(detaching);
      detach(if_block0_anchor);
      if (detaching) detach(t0);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t1);
      if_block2.d(detaching);
      if (detaching) detach(if_block2_anchor);
    }
  };
}

function booleanAttributeIsTrue(attributeValue) {
  return Boolean(typeof attributeValue === "string" || attributeValue);
}

function getDisabledVariation(disable) {
  return disable === "dark" ? "dark" : "light";
}

function getRelKeywords(opener, rel) {
  var relKeywords = [booleanAttributeIsTrue(opener) ? "" : "noopener", rel].filter(Boolean).join(" ");
  return relKeywords.length ? relKeywords : null;
}

function instance($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, buttonStyleStore, function ($$value) {
    return $$invalidate(9, $altStyles = $$value);
  });
  var buttonStylesheet = "<style id=\"bare-button\">".concat(styles$3, "</style>");
  var style = new StyleUtilities(buttonStyles);
  var formParticipant;
  var iconLabelTheme;
  var _$$props$disable = $$props.disable,
      disable = _$$props$disable === void 0 ? false : _$$props$disable;
  var _$$props$href = $$props.href,
      href = _$$props$href === void 0 ? "" : _$$props$href;
  var _$$props$iconposition = $$props.iconposition,
      iconposition = _$$props$iconposition === void 0 ? "left" : _$$props$iconposition;
  var _$$props$iconspace = $$props.iconspace,
      iconspace = _$$props$iconspace === void 0 ? "mini" : _$$props$iconspace;
  var _$$props$label = $$props.label,
      label = _$$props$label === void 0 ? "" : _$$props$label;
  var _$$props$opener = $$props.opener,
      opener = _$$props$opener === void 0 ? false : _$$props$opener;
  var _$$props$pressed = $$props.pressed,
      pressed = _$$props$pressed === void 0 ? false : _$$props$pressed;
  var _$$props$rel = $$props.rel,
      rel = _$$props$rel === void 0 ? null : _$$props$rel;
  var _$$props$shadowed = $$props.shadowed,
      shadowed = _$$props$shadowed === void 0 ? false : _$$props$shadowed;
  var _$$props$shape = $$props.shape,
      shape = _$$props$shape === void 0 ? "pill" : _$$props$shape;
  var _$$props$size = $$props.size,
      size = _$$props$size === void 0 ? "medium" : _$$props$size;
  var _$$props$target = $$props.target,
      target = _$$props$target === void 0 ? null : _$$props$target;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "white" : _$$props$theme;
  var _$$props$toggle = $$props.toggle,
      toggle = _$$props$toggle === void 0 ? false : _$$props$toggle;
  var _$$props$type = $$props.type,
      type = _$$props$type === void 0 ? "button" : _$$props$type;

  function forwardFormSubmission(event) {
    participateInForm(type, formParticipant, style.usesPolyfill);
  }

  function getOptionalClassNames(disable, pressed, shadowed, shape, size, theme, toggle) {
    var optionalClassNames = [$altStyles.style("size/".concat(size)), $altStyles.variant("size/".concat(size, "/").concat(shape)), $altStyles.style("theme/".concat(theme)), booleanAttributeIsTrue(disable) && $altStyles.style("disable/disable"), booleanAttributeIsTrue(disable) && $altStyles.variant("disable/disable/".concat(getDisabledVariation(disable))), booleanAttributeIsTrue(pressed) && $altStyles.variant("theme/".concat(theme, "/pressed")), booleanAttributeIsTrue(shadowed) && $altStyles.variant("theme/".concat(theme, "/shadowed")), booleanAttributeIsTrue(toggle) && $altStyles.variant("theme/".concat(theme, "/toggle"))].filter(Boolean).join(" ");
    return optionalClassNames.length ? optionalClassNames : "";
  }

  function generatePolyfillStyleTags() {
    var tags = polyfillStyleTags;

    if (buttonStyleStore.isNewStylesheet("bare-button")) {
      tags += buttonStylesheet;
    }

    if (buttonStyleStore.isNewStylesheet("size/".concat(size))) {
      tags += $altStyles.sheet("size/".concat(size));
    }

    if (buttonStyleStore.isNewStylesheet("theme/".concat(theme))) {
      tags += $altStyles.sheet("theme/".concat(theme));
    }

    if (buttonStyleStore.isNewStylesheet("disable/disable")) {
      tags += $altStyles.sheet("disable/disable");
    }

    return tags;
  }

  function initializeFormParticipant$1(event) {
    formParticipant = initializeFormParticipant(type, event.target.assignedNodes());
  }

  $$self.$set = function ($$props) {
    if ("disable" in $$props) $$invalidate(19, disable = $$props.disable);
    if ("href" in $$props) $$invalidate(1, href = $$props.href);
    if ("iconposition" in $$props) $$invalidate(2, iconposition = $$props.iconposition);
    if ("iconspace" in $$props) $$invalidate(0, iconspace = $$props.iconspace);
    if ("label" in $$props) $$invalidate(3, label = $$props.label);
    if ("opener" in $$props) $$invalidate(20, opener = $$props.opener);
    if ("pressed" in $$props) $$invalidate(21, pressed = $$props.pressed);
    if ("rel" in $$props) $$invalidate(22, rel = $$props.rel);
    if ("shadowed" in $$props) $$invalidate(23, shadowed = $$props.shadowed);
    if ("shape" in $$props) $$invalidate(24, shape = $$props.shape);
    if ("size" in $$props) $$invalidate(4, size = $$props.size);
    if ("target" in $$props) $$invalidate(5, target = $$props.target);
    if ("theme" in $$props) $$invalidate(6, theme = $$props.theme);
    if ("toggle" in $$props) $$invalidate(18, toggle = $$props.toggle);
    if ("type" in $$props) $$invalidate(7, type = $$props.type);
  };

  var formattedRel;
  var isDisabled;
  var optionalClassNames;
  var polyfillStyleTags;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*opener, rel*/
    5242880) {
       $$invalidate(11, formattedRel = getRelKeywords(opener, rel));
    }

    if ($$self.$$.dirty &
    /*shape*/
    16777216) {
      // visually hide label for icon-only circle buttons
       $$invalidate(8, iconLabelTheme = shape === "circle" ? "visually-hidden-text" : undefined);
    }

    if ($$self.$$.dirty &
    /*shape, iconspace*/
    16777217) {
      // force no iconspace when circle button
       $$invalidate(0, iconspace = shape === "circle" ? "none" : iconspace);
    }

    if ($$self.$$.dirty &
    /*disable*/
    524288) {
       $$invalidate(12, isDisabled = booleanAttributeIsTrue(disable));
    }

    if ($$self.$$.dirty &
    /*pressed, toggle*/
    2359296) {
      // pressed implies a toggle
       $$invalidate(18, toggle = pressed ? pressed : toggle);
    }

    if ($$self.$$.dirty &
    /*disable, pressed, shadowed, shape, size, theme, toggle*/
    28049488) {
       $$invalidate(13, optionalClassNames = getOptionalClassNames(disable, pressed, shadowed, shape, size, theme, toggle));
    }

    if ($$self.$$.dirty &
    /*size, theme*/
    80) {
       $$invalidate(10, polyfillStyleTags = style.usesPolyfill ? generatePolyfillStyleTags() : null);
    }
  };

  return [iconspace, href, iconposition, label, size, target, theme, type, iconLabelTheme, $altStyles, polyfillStyleTags, formattedRel, isDisabled, optionalClassNames, buttonStylesheet, style, forwardFormSubmission, initializeFormParticipant$1, toggle, disable, opener, pressed, rel, shadowed, shape];
}

var DlsButton =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsButton, _SvelteElement);

  function DlsButton(options) {
    var _this;

    _classCallCheck(this, DlsButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsButton).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance, create_fragment, safe_not_equal, {
      disable: 19,
      href: 1,
      iconposition: 2,
      iconspace: 0,
      label: 3,
      opener: 20,
      pressed: 21,
      rel: 22,
      shadowed: 23,
      shape: 24,
      size: 4,
      target: 5,
      theme: 6,
      toggle: 18,
      type: 7
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsButton, [{
    key: "disable",
    get: function get() {
      return this.$$.ctx[19];
    },
    set: function set(disable) {
      this.$set({
        disable: disable
      });
      flush();
    }
  }, {
    key: "href",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(href) {
      this.$set({
        href: href
      });
      flush();
    }
  }, {
    key: "iconposition",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(iconposition) {
      this.$set({
        iconposition: iconposition
      });
      flush();
    }
  }, {
    key: "iconspace",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(iconspace) {
      this.$set({
        iconspace: iconspace
      });
      flush();
    }
  }, {
    key: "label",
    get: function get() {
      return this.$$.ctx[3];
    },
    set: function set(label) {
      this.$set({
        label: label
      });
      flush();
    }
  }, {
    key: "opener",
    get: function get() {
      return this.$$.ctx[20];
    },
    set: function set(opener) {
      this.$set({
        opener: opener
      });
      flush();
    }
  }, {
    key: "pressed",
    get: function get() {
      return this.$$.ctx[21];
    },
    set: function set(pressed) {
      this.$set({
        pressed: pressed
      });
      flush();
    }
  }, {
    key: "rel",
    get: function get() {
      return this.$$.ctx[22];
    },
    set: function set(rel) {
      this.$set({
        rel: rel
      });
      flush();
    }
  }, {
    key: "shadowed",
    get: function get() {
      return this.$$.ctx[23];
    },
    set: function set(shadowed) {
      this.$set({
        shadowed: shadowed
      });
      flush();
    }
  }, {
    key: "shape",
    get: function get() {
      return this.$$.ctx[24];
    },
    set: function set(shape) {
      this.$set({
        shape: shape
      });
      flush();
    }
  }, {
    key: "size",
    get: function get() {
      return this.$$.ctx[4];
    },
    set: function set(size) {
      this.$set({
        size: size
      });
      flush();
    }
  }, {
    key: "target",
    get: function get() {
      return this.$$.ctx[5];
    },
    set: function set(target) {
      this.$set({
        target: target
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[6];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }, {
    key: "toggle",
    get: function get() {
      return this.$$.ctx[18];
    },
    set: function set(toggle) {
      this.$set({
        toggle: toggle
      });
      flush();
    }
  }, {
    key: "type",
    get: function get() {
      return this.$$.ctx[7];
    },
    set: function set(type) {
      this.$set({
        type: type
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["disable", "href", "iconposition", "iconspace", "label", "opener", "pressed", "rel", "shadowed", "shape", "size", "target", "theme", "toggle", "type"];
    }
  }]);

  return DlsButton;
}(SvelteElement);

// TODO: don't call by default later, will be breaking change

try {
  window.customElements.define('dls-button', DlsButton);
} catch (error) {// TODO: See https://github.com/collectivehealth/dls/issues/552
  // eslint-disable-next-line no-console
  // console.error(
  //   `Your bundle may include ${tagName} more than once.`,
  //   error
  // );
}

export default DlsButton;
export { addStyles };
